export const SESSION_ID = 'session_id';
